import React from "react";
import { Button } from "@/components/ui/button";
export default function ReadyToFly() {
  return <section data-section-id="198351" id="start-your-spanish-adventure" className="w-full bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
      <div className="w-full max-w-4xl mx-auto">
        <div className="bg-indigo-600 rounded-[2.5rem] sm:rounded-[3rem] p-10 sm:p-16 md:p-20 text-center flex flex-col items-center justify-center shadow-[0_20px_60px_-15px_rgba(99,102,241,0.3)] border border-white/10 transition-all duration-500 hover:shadow-[0_20px_60px_-10px_rgba(99,102,241,0.4)]">
          
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-serif tracking-tight text-white mb-8 max-w-2xl mx-auto leading-tight">
            Ready to Start the Adventure? <br className="hidden sm:block" />
            <span className="text-primary">Your child&apos;s Spanish journey begins here.</span>
          </h2>
          
          <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/40 hover:shadow-xl hover:shadow-primary/60 transition-all duration-300 text-xl h-16 px-12 rounded-full font-serif">
            Book a Trial Lesson
          </Button>
          
          <p className="text-base text-indigo-100 mt-6 font-sans font-medium tracking-wide uppercase">
            Give your child a fun first step into Spanish!
          </p>
          
        </div>
      </div>
    </section>;
}